module.exports = __webpack_public_path__ + "img/ic_activity_badge.3498492f.svg";